/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/
import React, { ReactElement, Suspense } from 'react';
import { Router } from 'react-router-dom';
import { createHashHistory } from 'history';
import { ApolloProvider } from '@apollo/client';
import { createGlobalStyle } from 'styled-components';

import { SpinnerFullPage } from '@gearz/spinner';
import ThemeManager from '@gearz/theme-manager';
import ThemeBaseStyles from '@userzoom-themes/peach/base-styles';
import ThemeGlobalStyles from '@userzoom-themes/peach/global-styles';
import ThemeIcons from '@userzoom-themes/peach/icons';

import Routes from './Routes';
import ErrorBoundary from './hocs/error-boundary';
import createGraphQlClient from './api/graphql-client';
import CookiesGuard from './hocs/cookies-guard';
import globalStyles from './styles/global';
import ThemeComponents from './styles/theme-components';
import Main from './components/main';

const hashHistory = createHashHistory();

const GlobalStyles = createGlobalStyle`${ThemeGlobalStyles}${globalStyles}`;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const graphQlClient = createGraphQlClient({ uri: (window as any).config.apiUrl ?? '' });

const App = (): ReactElement => (
  <ErrorBoundary>
    <ApolloProvider client={graphQlClient}>
      <ThemeManager base={ThemeBaseStyles} icons={ThemeIcons} styles={ThemeComponents}>
        <GlobalStyles />
        <Router history={hashHistory}>
          <Suspense fallback={<SpinnerFullPage />}>
            <Main>
              <CookiesGuard>
                <Routes />
              </CookiesGuard>
            </Main>
          </Suspense>
        </Router>
      </ThemeManager>
    </ApolloProvider>
  </ErrorBoundary>
);

export default App;
